import autoSizeFromParentBoundsFactory from 'components/auto-size-from-parent-bounds';
import D3 from './D3';

const D3WithAutoSize = autoSizeFromParentBoundsFactory(D3);

export default D3WithAutoSize;
export { D3WithAutoSize as D3 };
